import intlTelInput from "intl-tel-input";

window.ValidationModule = (function(w, $) {

    const settings = {
        $hasErrors: false,
        $instagram: $('#instagram') || null,
    };

    // initialize Module
    const init = () => {
        const _s = settings;
        // console.log('initialize Validation Module');

        //   QuestionsModule.init();

        bindUIActions(_s);
        hasErrors(_s);
        validateForm($('.step--1 .form .required, .step--1 .form #questions').not('.on-vue'), true);

        //
        // if($('.phone-international').length) {
        //     const input = document.querySelector(".phone-international");
        //     _s.phoneInternational = intlTelInput(input, {
        //         autoPlaceholder: "polite",
        //     });
        //
        //     input.addEventListener('keyup', formatIntlTelInput);
        //     input.addEventListener('change', formatIntlTelInput);
        //
        //     function formatIntlTelInput() {
        //         if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
        //             var currentText = _s.phoneInternational.getNumber(intlTelInputUtils.numberFormat.E164);
        //             if (typeof currentText === 'string') { // sometimes the currentText is an object :)
        //                 _s.phoneInternational.setNumber(currentText); // will autoformat because of formatOnDisplay=true
        //             }
        //         }
        //     }
        // }
    };

    function bindUIActions(_s) {
        $('.form .button').not('on-vue').on('click', function(e) {
            if ($(this).hasClass('button--override')) return false

            disableSubmit($(this), e);
        });

        $('input, textarea, select').not('on-vue').on('keydown', function(e) {
            if (e.which == 13) {
                addFormButtonError($(this).closest('.form:not(.no-validation)').find('.button'));
            }
        });

        $('.form .required, .form #questions, .form .linkedInInstaWeb').not('on-vue').on('keyup change', function() {
            validateForm($(this));
            removeError($(this));

            if($(this).is('#confirm_password')) {
                removeError($('#password'));
            }
        });

        $('.form #social-media').not('on-vue').on('change', function() {
            $('.social-row').hide();
            $('.linkedInInstaWeb').val(null);
            $('.'+$(this).val()+'-row').css('display','flex');
            validateForm($(this));
            removeError($(this));
        });

        $('.form #js-accept-crop').not('on-vue').on('click', function() {
            var $field = $(this).closest('.form__field--image');

            $field.addClass('is-accepted');

            validateForm($field.find('.required'));
            removeError($field.find('.required'));
        });

        $('.form #js-cancel-crop').not('on-vue').on('click', function() {
            var $field = $(this).closest('.form__field--image');

            $field.removeClass('is-accepted');
            $field.removeClass('is-interacted');
        });

        $('#password').not('on-vue').on('blur', function() {
            var field = $('#password').closest('.form__field');

            field.addClass('has-error');

            if(!validatePasswordLength() && !field.find('.length-error').length) {
                $('<span class="error length-error">Your password must be a minimum of 6 characters.</span>').insertAfter('#password').hide().fadeIn(500);
            }
        });

        $('#confirm_password').not('on-vue').on('blur', function() {
            var field = $('#password').closest('.form__field');

            field.addClass('has-error');

            if(!validatePasswordMatch() && !field.find('.match-error').length) {
                $('<span class="error match-error">Your passwords don\'t match.</span>').insertAfter('#password').hide().fadeIn(500);
            }

            if(!validatePasswordLength() && !field.find('.length-error').length) {
                $('<span class="error length-error">Your password must be a minimum of 6 characters.</span>').insertAfter('#password').hide().fadeIn(500);
            }
        });

        if($('#username').not('on-vue').length) {
            $('#username').not('on-vue').on('blur', function () {
                const input = this
                const username = input.value

                axios.get(`/api/duplicate/${username}`)
                    .then(res => {
                        const {isFree} = res.data

                        if (!isFree) {
                            var $usernameField = $(this).closest('.form__field');

                            $usernameField.addClass('has-error');

                            if (!$usernameField.find('.error').length) {
                                $('<span class="error">The username has already been taken.</span>').insertAfter('#username').hide().fadeIn(500);
                            }
                        }
                        validateForm($(this));
                    })
                    .catch(err => {
                        // console.log(err)
                    })
            });

            $('#username').not('on-vue').on('blur', function () {


                const input = this
                const username = input.value

                if(!validateUsername(input.value))
                {
                    var $usernameField = $(this).closest('.form__field');
                    $usernameField.addClass('has-error');
                    if (!$usernameField.find('.error').length) {
                        $('<span class="error">Username may not use special characters like @$&^.</span>').insertAfter('#username').hide().fadeIn(500);
                    }
                }
            });
        }

        // if($('.phone-international').not('on-vue').length) {
        //     $('.phone-international').not('on-vue').on('blur', function () {
        //         validateForm($(this));
        //     });
        // }


        if($('.referral-email').not('on-vue').length) {
            $('.referral-email').not('on-vue').on('blur', function () {
                const input = this
                const email = input.value

                var userid = $('input[name="user_id"]').val() || null;

                axios.get(`/api/duplicate-email/${email}/${userid}/`)
                    .then(res => {
                        const {isFree} = res.data

                        if (!isFree) {
                            var $emailField = $(this).closest('.form__field');

                            $emailField.addClass('has-error');

                            if (!$emailField.find('.error').length) {
                                $('<span class="error">The email has already been taken.</span>').insertAfter('.referral-email').hide().fadeIn(500);
                            }
                        }
                        validateForm($(this));
                    })
                    .catch(err => {
                        // console.log(err)
                    })
            });
        }


        if($('.application-email').not('on-vue').length) {
            $('.application-email').not('on-vue').on('blur', function () {
                const input = this
                const email = input.value
                var userid = null;

                axios.get(`/api/duplicate-email/${email}/${userid}/`)
                    .then(res => {
                        const {isFree} = res.data

                        if (!isFree) {
                            var $this = $(this).closest('.form__field');

                            $this.addClass('has-error');

                            if (!$this.find('.error').length) {
                                $('<span class="error">The email has already been taken.</span>').insertAfter('.application-email').hide().fadeIn(500);
                            }
                        }
                        validateForm($(this));
                    })
                    .catch(err => {
                        // console.log(err)
                    })
            });
        }

        $('#profile_picture').not('on-vue').closest('.form').find('.button.disabled').on('click', function() {
            var $field = $('#profile_picture').closest('.form__field--image');

            $field.addClass('has-error');

            if(!$field.find('.error').length) {
                if(!validateProfilePictureUploaded()) {
                    $('<span class="error">Please upload your profile photo.</span>').insertAfter('.crop-wrapper').hide().fadeIn(500);
                } else if(!validateProfilePictureAccepted()) {
                    $('<span class="error">Please confirm your profile photo by selecting the checkmark.</span>').insertAfter('.crop-wrapper').hide().fadeIn(500);
                }
            }
        });
    }


    function validateForm(that, isInit) {

        var form = that.closest('.form');
        var fields = form.find('input, textarea, select').not('.on-vue');
        var button = form.find('.button').not('.on-vue');

        var overAllValid = true;
        // console.log(form)
        // console.log(fields)
        // console.log(button)
        // console.log(1)

        fields.each(function() {
            // console.log(2)

            var isValid = true;

            // If field is in the questions component
            var $questions = $(this).closest('#questions');
            if($(this).closest('#questions').length) {
                // If there are less than 1 or more than 3 active questions
                var length = 0;

                if($('body').hasClass('has-errors')) {
                    length = $questions.find('input[type="checkbox"]:checked').length;

                    if(length > 2) {
                        $questions.addClass('disable-inactive');
                    }
                } else {
                    length = QuestionsModule.getNumActiveQuestions();
                }

                if(length < 3) {
                    isValid = false;
                }
            }

            if($(this).hasClass('linkedInInstaWeb')){
                if(!validateLinkedInInstaWeb()){
                    $(this).addClass('input-error');
                    isValid = false;
                }else{
                    $(this).removeClass('input-error button-error');
                    $(this).nextAll('.error').remove();
                }
            }

            // if($(this).hasClass('phone-international')){
            //
            //     if($(this).val() != '')
            //     {
            //         // console.log(settings.phoneInternational.isValidNumber());
            //         if(!settings.phoneInternational.isValidNumber()){
            //             $(this).addClass('input-error');
            //             isValid = false;
            //         }
            //         $("input[name=full_phone]").val(settings.phoneInternational.getNumber());
            //     }
            // }

            // If field is required and not hidden
            if($(this).hasClass('required') && !$(this).closest('.hidden').length) {
                var value = $.trim($(this).val());

                // If email field is not a valid email format
                if($(this).attr('type') === 'email' && !validateEmail(value)) {
                    isValid = false;
                }

                // If a required checkbox isn't checked
                if($(this).attr('type') === 'checkbox' && !$(this).is(':checked')) {
                    isValid = false;
                }

                // If no required special checkboxes are checked
                var checkboxValid = false;

                if($(this).closest('.form__field--checkbox-required').length) {
                    $(this).closest('.form__row').find('input[type="checkbox"]').each(function() {
                        if($(this).is(':checked')) {
                            checkboxValid = true;
                        }
                    });

                    if(!checkboxValid) {
                        isValid = false;
                    } else {
                        isValid = true;
                    }
                }

                // If a required radio button isn't checked
                var radioValid = false;

                $(this).closest('.form__row').find('input[type="radio"]').each(function() {
                    if($(this).is(':checked')) {
                        radioValid = true;
                    }
                });

                if($(this).attr('type') === 'radio' && !radioValid) {
                    isValid = false;
                }

                if($('#password').length) {
                    if($('#confirm_password').length) {
                        // If password and confirm password are not equal
                        if(($(this).is('#password') || $(this).is('#confirm_password') ) && !validatePasswordMatch()) {
                            isValid = false;
                        }
                    }

                    // If password and confirm password are a minimmum of 6 characters
                    if(($(this).is('#password') || $(this).is('#confirm_password') ) && !validatePasswordLength()) {
                        isValid = false;
                    }
                }
                if($('input[name="email"]').length) {
                    if($(this).is('input[name="email"]') && $(this).closest('.form__field').hasClass('has-error'))
                    {
                        isValid = false;
                    }
                }

                if($('#username').length) {
                    if($(this).is('#username') && $(this).closest('.form__field').hasClass('has-error'))
                    {
                        isValid = false;
                    }
                    if($(this).is('#username') && !validateUsername(value))
                    {
                        isValid = false;
                    }
                }

                // If hasn't reached min characters
                if($(this).data('minlength')) {
                    var minLength = $(this).data('minlength');

                    if(value.toString().length < minLength) {
                        isValid = false;
                    }
                }

                if($(this).closest('.form__field--image').length) {
                    // If image crop has not been accepted
                    if(!$(this).closest('.form__field--image').hasClass('is-accepted')) {
                        isValid = false;
                    }
                } else {
                    // If field is empty
                    if (value === '' || value === null || value === undefined || typeof(value) === 'undefined') {
                        isValid = false;
                    }
                }


            }

            if(!isValid){
                overAllValid = false;
                $(this).addClass('input-error');
            }else{
                $(this).removeClass('input-error button-error');
                $(this).nextAll('.error').remove();
            }
        });

        if(overAllValid) {
            button.removeClass('disabled');

            $('.form__button .error').fadeOut('fast', function() {
                $(this).remove();
            });

            if(!isInit) {
                removeError(that);
            }
        } else {
            button.addClass('disabled');
        }
    }

    function disableSubmit(that, event) {
        if(that.hasClass('disabled')) {
            event.preventDefault();
            addFormButtonError(that);
        }
        else{
            var fields = that.closest('form').find('input, textarea, select');
            fields.each(function() {
                $(this).removeClass('input-error button-error');
            });
            $('.error').remove();
        }
    }

    function addFormButtonError(button) {

        if (!button.closest('.form__button').find('.error').length) {
            var inputButton = button.closest('.form__row--input-button').find('.form__field');

            if(button.closest('form').hasClass('questions-form')){
                $('<span class="error">Please complete all three profile questions.</span>').insertAfter(inputButton.length ? inputButton : button).hide().fadeIn(500);
            }else if(button.closest('form').hasClass('no-button-error')){
                $('<span class="error"></span>').insertAfter(inputButton.length ? inputButton : button).hide().fadeIn(500);
            }else {

                var profile_photo_error = '';
                if(button.closest('.form').find('#profile_picture').length) {
                    if (!validateProfilePictureUploaded()) {
                        profile_photo_error = "Please upload your profile photo";
                    } else if (!validateProfilePictureAccepted()) {
                        profile_photo_error = "Please confirm your profile photo by selecting the checkmark.";
                    }
                }
                if(profile_photo_error != '') {
                    $('<span class="error">'+profile_photo_error+'</span>').insertAfter(inputButton.length ? inputButton : button).hide().fadeIn(500);
                }else{
                    $('<span class="error">Some fields are missing or incomplete.</span>').insertAfter(inputButton.length ? inputButton : button).hide().fadeIn(500);
                }
            }

            var fields = button.closest('form').find('input, textarea, select');

            fields.each(function() {
                if($(this).hasClass('input-error'))
                {
                    $(this).addClass('button-error');

                    var message = $(this).attr('placeholder').replace("Enter", "");
                    var show_error = true;

                    if(message == '')
                        show_error = false;

                    // if($(this).hasClass('phone-international'))
                    //     message = 'valid phone number';
                    if($(this).hasClass('social-instagram'))
                        message = 'your Instagram Handle. No need for the @ sign.';
                    if($(this).hasClass('social-linkedIn'))
                        message = 'your LinkedIn Profile URL.';
                    if($(this).hasClass('social-website'))
                        message = 'your Website URL.';


                    if($(this).hasClass('how_hear_about'))
                        $('#how_hear').addClass('button-error');
                    if($(this).hasClass('legal-checkbox'))
                        $('#legal-info').addClass('button-error');

                    message = "Please enter "+message;

                    if(($(this).hasClass('application-email') || $(this).hasClass('referral-email'))  && !validateEmail($(this).val()))
                        message = 'Please provide a valid email address.';
                    if(($(this).hasClass('application-email') || $(this).hasClass('referral-email')) && validateEmail($(this).val()))
                        show_error = false;

                    if($(this).hasClass('confirm-pass'))
                        message = 'Please re-enter your password';

                    if($(this).data('error'))
                        message = $(this).data('error');

                    if($(this).is('#username') && !validateUsername($(this).val()))
                        show_error = false;

                    if(show_error)
                        $(this).after('<span class="error">'+message+'</span>');
                }
            });

        }
    }

    function removeError(that) {
        // Remove error message once field has been interacted with
        that.nextAll('.error').remove();
        that.closest('.has-error').removeClass('has-error button-error').find('.error').slideUp(function() {
            $(this).remove();
        })
            .animate(
                { opacity: 0 },
                { queue: false, duration: 'fast' }
            );
    }

    function hasErrors(_s) {
        if($('body').hasClass('has-errors')) {
            _s.$hasErrors = true;

            addDynamicError();
        }
    }

    function addDynamicError() {
        if($('.has-dynamic-error').length) {
            $('.has-dynamic-error').each(function() {
                var name = $(this).find('input, textarea, select').attr('name').replace(/_/g, ' ');

                var isFile = $(this).find('input[type="file"]').length;
                var isSelect = $(this).find('select').length;

                var action;
                if(isFile) {
                    action = 'upload';
                } else if(isSelect) {
                    action = 'select';
                } else {
                    action = 'fill out';
                }

                // Add error text to field without error on a page with an error
                if($(this).length && !$(this).find('.error').length) {
                    $(this).addClass('has-error').append(`<span class="error">Please ${action} your ${name} again.</span>`);
                }
            });
        }
    }

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function validateUsername(username) {
        if(/[^a-zA-Z0-9]/.test(username)) {
            return false;
        }
        return true;
    }

    function validatePasswordMatch() {
        return $('#password').val() === $('#confirm_password').val();
    }

    function validatePasswordLength() {
        return $('#password').val().length >= 6;
    }

    function validateProfilePictureUploaded() {
        var $field = $('#profile_picture').closest('.form__field--image');

        return $field.hasClass('is-interacted');
    }

    function validateProfilePictureAccepted() {
        var $field = $('#profile_picture').closest('.form__field--image');

        return $field.hasClass('is-accepted');
    }

    function validateLinkedInInstaWeb() {
        if ($("input[name='linkedIn']").val() == '' && $("input[name='instagram']").val() == '' && $("input[name='website']").val() == '')
            return false;
        return true;
    }

    return { init, validateForm };
})(window, jQuery)
